import { prop, pick } from 'ramda';
import React, { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { ReCaptcha } from 'js/components/main/ReCaptcha';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as actions from '../../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../../store';

import style from './Captcha.scss';

export const Captcha: React.FC = () => {
    const translate = useComponentTranslations();
    const dispatch = useDynamicReducerDispatch();
    const isRecaptchaShown = useDynamicReducerSelector(prop('isRecaptchaShown'));
    const { casinoName, ssoPasDomain } = useAppSelector(pick(['casinoName', 'ssoPasDomain']));

    const onReCaptchaTokenValidate = useCallback(() => {
        dispatch(actions.setIsRecaptchaShown(false));
        dispatch(actions.setIsWaitingForBankIdConfirmation(false));
    }, [dispatch]);

    const onReCaptchaTokenError = useCallback(() => {
        dispatch(actions.setFormError(translate('playtech.mobile.system.bankIDAuth.recaptcha.error')));
    }, [dispatch, translate]);

    return (
        isRecaptchaShown ? (
            <div className={style.captcha}>
                <ReCaptcha
                    operation={'login'}
                    casinoName={casinoName}
                    ssoPasDomain={ssoPasDomain}
                    onValidate={onReCaptchaTokenValidate}
                    onError={onReCaptchaTokenError}
                />
            </div>
        ) : null
    );
};
